import React from 'react';
import { Redirect } from 'react-router-dom';

const ErrorRedirect = () => {
  return (
    <Redirect to={{pathname: '/404'}}/>
  );
};

export default ErrorRedirect;



// WEBPACK FOOTER //
// ./src/components/ErrorRedirect.js